import { useState } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { MdStar } from 'react-icons/md'
import ReviewModal from 'course/review/review-modal'
import { NeutralButtonOutline, SecondaryButton } from 'common/button'
import { Typography } from 'common/typography'
import ContentRenderer from 'content-renderer'

const LastViewLessonStyled = styled.div`
  h3 {
    margin-bottom: 8px;
  }
  p {
    font: normal 14px/22px var(--primaryFont);
  }
  .progress-line {
    margin: 24px 0;
    height: 4px;
    background-color: var(--neutral60);
    border-radius: 8px;
  }
  .progress-bar {
    height: 100%;
    width: ${({ advance }) => `${advance}%`};
    background-color: var(--secondary);
    border-radius: 8px;
  }
  .play {
    margin-right: 8px;
  }
  ${NeutralButtonOutline} {
    margin-top: 16px;
    svg {
      margin-right: 8px;
    }
  }
  @media(min-width: 768px) {
    .hero-btns {
      display: flex;
      align-items: center;
    }
    ${NeutralButtonOutline} {
      margin-top: 0;
      margin-left: 24px;
    }
  }
`

function LastViewLesson({ lesson, course, review }) {
  const {
    title, slug, total_duration, video, content: { blocks },
  } = lesson
  const [isActiveModal, setIsActiveModal] = useState(false)
  const handleOpenModal = () => {
    setIsActiveModal(!isActiveModal)
  }

  const progress = video?.progress || 0

  const advance = Math.round((100 / total_duration) * progress)
  return (
    <LastViewLessonStyled advance={advance}>
      <Typography as="h3" font="regular" color="var(--baseNeutral)">
        {'Clase: '}
        {title}
      </Typography>
      <ContentRenderer chunks={blocks.slice(0, 1)} />
      <div className="progress-line">
        <div className="progress-bar" />
      </div>
      <div className="hero-btns">
        <Link href={`/aprender/${course}/${slug}`} passHref>
          <SecondaryButton fullWidth fitContent height="48">
            <img width="20" height="20" alt="Icono de Play" src="/images/icons/play.png" className="play" />
            Continuar viendo
          </SecondaryButton>
        </Link>
        {!review && (
          <NeutralButtonOutline height="48" onClick={() => handleOpenModal()} fullWidth fitContent>
            <MdStar size="23" />
            Valorar Curso
          </NeutralButtonOutline>
        )}
        <ReviewModal isActiveModal={isActiveModal} handleClick={handleOpenModal} />
      </div>
    </LastViewLessonStyled>
  )
}

export default LastViewLesson
